import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSun, FaMoon, FaSignOutAlt, FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { auth } from '../utils/auth';

function AdminHeader({ toggleSidebar, isSidebarOpen }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  };

  const handleLogout = () => {
    auth.logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  const handleToggleSidebar = () => {
    console.log('Toggle button clicked, isSidebarOpen:', isSidebarOpen, 'new state:', !isSidebarOpen);
    toggleSidebar();
  };

  return (
    <header
      className={`bg-white dark:bg-gray-700 shadow-md p-4 flex justify-between items-center sticky top-0 z-30 transition-all duration-300 ${
        isSidebarOpen ? 'lg:ml-64' : 'lg:ml-16'
      }`}
      onTransitionEnd={() => console.log('Header margin:', isSidebarOpen ? 'ml-64' : 'ml-16')}
    >
      <div className="flex items-center space-x-4">
        <button
          className="text-gray-600 dark:text-gray-300 p-2 rounded-full hover:bg-blue-100 dark:hover:bg-blue-800 transition duration-200"
          onClick={handleToggleSidebar}
          aria-label={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          {isSidebarOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
        <h1 className="text-xl font-bold text-blue-600 dark:text-blue-400">Poultry Admin</h1>
      </div>
      <div className="relative flex items-center space-x-4">
        {/* <button
          onClick={toggleTheme}
          className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600"
          aria-label="Toggle theme"
        >
          {theme === 'light' ? <FaMoon size={20} /> : <FaSun size={20} />}
        </button> */}
        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center space-x-2 p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-600"
            aria-label="User menu"
          >
            <FaUser size={20} />
            <span className="hidden md:block text-sm font-medium">{user.name || 'Admin'}</span>
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-700 rounded-md shadow-lg py-1 z-10">
              <div className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 border-b dark:border-gray-600">
                {user.email}
              </div>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover: dark:hover:bg-gray-600 flex items-center"
              >
                <FaSignOutAlt className="mr-2" /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default AdminHeader;